const service = undefined;
// 前台路由
const web_routers = [
  {
    path: "leadingDriver",
    name: "leadingDriver",
    component: {
      render: (e) => e("router-view"),
    },
    redirect: { name: "personnelOverview" },
    meta: {
      title: "领导驾驶舱",
    },
    children: [
      {
        path: "personnelOverview",
        name: "personnelOverview",
        component: () =>
          import(
            /* webpackChunkName: "[request]" */ "../views/forestage/personnelOverview/Index.vue"
          ),
        meta: {
          title: "人事概况",
          showHeader: false,
          showFoot: false,
          showSide: false,
          showAI: false,
        },
      },
      {
        path: "schoolOverview",
        name: "schoolOverview",
        component: () => import("../views/forestage/schoolOverview/Index.vue"),
        meta: {
          title: "校情总览",
          showHeader: false,
          showFoot: false,
          showSide: false,
          showAI: false,
        },
      },
      {
        path: "teachingOverview",
        name: "teachingOverview",
        component: () =>
          import(
            /* webpackChunkName: "[request]" */
            "../views/forestage/teachingOverview/Index.vue"
          ),
        meta: {
          title: "教学概况",
          showHeader: false,
          showFoot: false,
          showSide: false,
          showAI: false,
        },
      },
      {
        path: "assetOverview",
        name: "assetOverview",
        component: () =>
          import(
            /* webpackChunkName: "[request]" */
            "../views/forestage/assetOverview/Index.vue"
          ),
        meta: {
          title: "资产概况",
          showHeader: false,
          showFoot: false,
          showSide: false,
          showAI: false,
        },
      },
      {
        path: "producteduOverview",
        name: "producteduOverview",
        component: () =>
          import(
            /* webpackChunkName: "[request]" */
            "../views/forestage/producteduOverview/Index.vue"
          ),
        meta: {
          title: "产教融合",
          showHeader: false,
          showFoot: false,
          showSide: false,
          showAI: false,
        },
      },
    ],
  },
];
export default {
  service,
  web: web_routers,
};
